import { Delete, Edit } from "@mui/icons-material";
import { Button, IconButton } from "@mui/material";
import { useFormikContext } from "formik";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import { useMemo } from "react";
import { tableConfig } from "../../../../../../../../../commons/table/tableConfig";
import { StyledResolucion } from "../../../../../../../../../styled/Prevencion";

const DosimetriaTable = ({
  handleOpenForm,
  handleDeleteDosimetria,
  data,
}) => {
  const { values } = useFormikContext();
  const disabled = !values.equipoRadiologico;

  const columns = useMemo(() => [
    {
      accessorKey: 'nombreTipoDosimetria',
      header: 'Tipo de Dosimetría',
    },
    {
      accessorKey: 'nombreMetodoDosimetria',
      header: 'Método de Dosimetría',
    },
    {
      accessorKey: 'cantidadPersonal',
      header: 'Cantidad de Personal',
    },
    {
      accessorKey: 'cuitResponsable',
      header: 'CUIT',
    },
  ], []);

  const table = useMaterialReactTable({
    ...tableConfig,
    columns,
    data: data || [],
    enableRowActions: true,
    enableColumnActions: false,
    positionActionsColumn: 'last',
    enablePagination: true,
    muiTableHeadCellProps: {
      ...tableConfig.muiTableHeadCellProps,
      justifyContent: 'end',
    },
    displayColumnDefOptions: {
      'mrt-row-actions': {
        header: 'Operaciones',
        muiTableHeadCellProps: {
          ...tableConfig.muiTableHeadCellProps,
          sx: {
            ...tableConfig.muiTableHeadCellProps.sx,
            justifyContent: 'center',
          }
        },
      },
    },
    initialState: {
      ...tableConfig.initialState,
      pagination: {
        pageSize: 5,
        pageIndex: 0,
      },
    },
    renderRowActions: ({ row }) => (
      <div style={{ display: 'flex', gap: '8px' }}>
        <IconButton
          color="primary"
          disabled={disabled}
          onClick={() => handleOpenForm({...row.original, index:row.index})}
          size="small"
        >
          <Edit />
        </IconButton>
        <IconButton
          color="error"
          disabled={disabled}
          onClick={() => handleDeleteDosimetria(row.index)}
          size="small"
        >
          <Delete />
        </IconButton>
      </div>
    ),
    renderTopToolbarCustomActions: () => (
      <StyledResolucion.HeaderContainer>
        <StyledResolucion.TableTitle>Dosimetría</StyledResolucion.TableTitle>
      </StyledResolucion.HeaderContainer>
    ),
    renderBottomToolbarCustomActions: () => (
      <Button
        color="primary"
        disabled={disabled}
        onClick={() => handleOpenForm(null)}
        sx={{ marginRight: 'auto' }}
      >
        Agregar
      </Button>
    ),
    muiSearchTextFieldProps: {
      placeholder: 'Buscar...',
      variant: 'outlined',
      size: 'small',
    },
    enableColumnFilters: false,
    enableGlobalFilter: false,
    enableFilters: false,
  });

  return (
    <StyledResolucion.TableContainer>
      <MaterialReactTable table={table} />
    </StyledResolucion.TableContainer>
  );
};

export default DosimetriaTable;